import axios from 'axios'
import { showToast } from './Toaster'


function remove_all_toasts() {
  document.querySelectorAll('.toast-global-container .catchy-toast').forEach(t => t.remove())
}
function getAuthToken() {
  const supplierToken = localStorage.getItem('supplier_token')
  const adminToken = localStorage.getItem('admin_token')

  const isAdminContext =
    window.location.pathname.startsWith('/main') ||
    window.location.pathname.startsWith('/admin')

  if (isAdminContext) {
    return adminToken || supplierToken || ''
  }
  return supplierToken || adminToken || ''
}

export const form_api_submit = async ({ 
  url, 
  method = 'POST', 
  data = {}, 
  curr_form_id = null,
  take_form_data = false,
  // headers = {},
  show_success_toast = true,
  show_error_toast = true,
  remove_pre_toasts = true,
}) => {
  // Find the submit button
  let submitButton = null
  let originalButtonText = null
  
  if (curr_form_id) {
    const form = document.querySelector(curr_form_id)
    if (form) {
      submitButton = form.querySelector('.form-submit-btn')
      if (submitButton) {
        originalButtonText = submitButton.innerHTML
        // Set loading state
        submitButton.innerHTML = `<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> <span>Loading...</span>`
        submitButton.disabled = true
      }
      
      // Clear old validation errors
      const oldErrors = form.querySelectorAll('.validation-error')
      oldErrors.forEach(el => el.remove())
      
      const oldInvalidInputs = form.querySelectorAll('.is-invalid')
      oldInvalidInputs.forEach(el => el.classList.remove('is-invalid'))
    }
  }

var base_url = process.env.VUE_APP_API_BASE_URL;
// var base_url = "http://127.0.0.1:8000/api";
  url = base_url + "/" + url;
  // Collect form data if needed
  let formData = data
  
  if (take_form_data && curr_form_id) {
    const form = document.querySelector(curr_form_id)
    if (form) {
      formData = new FormData(form)
    }
  }
  if(remove_pre_toasts) {
    remove_all_toasts();
  }

  try {
    var axios_config = {
    method: method.toLowerCase(),
    url: url,
    headers: {
    Authorization: `Bearer ${getAuthToken()}`,
    'X-Company-Id': localStorage.getItem('company_id') || 'null',
  }
    
};
console.log('Company ID:', axios_config.headers['X-Company-Id']);
if (axios_config.method === 'get') {
    // GET requests pass data as URL query parameters (?page=1)
    axios_config.params = formData; 
} else {
    // POST, PUT, PATCH pass data in the request body payload
    axios_config.data = formData; 
}

const response = await axios(axios_config);

    // Reset button state on success
    if (submitButton) {
      submitButton.innerHTML = originalButtonText
      submitButton.disabled = false
    }

    if(show_success_toast) {  
        showToast(response.data?.message || 'Request successful', true)
    }

    return response.data;

  } catch (error) {
    // Reset button state on error
    if (submitButton) {
      submitButton.innerHTML = originalButtonText
      submitButton.disabled = false
    }

    if(show_error_toast) {  
        showToast(error.response.data?.message || 'Request failed', false)
    }


    console.log("API Error:", error.response);
    if (error.response?.data?.data?.error_type == 'validation' && curr_form_id) {
      const form = document.querySelector(curr_form_id)
      const errors = error.response.data?.data?.errors || {}
      
      Object.keys(errors).forEach(field => {
        let cleanField = field.replace(/\.\d+$/, '');
        const fieldName = cleanField.replace('[]', '');
        const fieldNames = [field, cleanField, fieldName, `${fieldName}[]`, `${fieldName}.0`, `${fieldName}.1`];
        
        let input = null;
        
        for (let name of fieldNames) {
          const element = form.querySelector(`[name="${name}"]`);
          if (element) {
            input = element;
            break;
          }
        }
        
        if (input) {
          input.classList.add('is-invalid')
          
          const errorDiv = document.createElement('div')
          errorDiv.className = 'validation-error'
          errorDiv.style.color = 'red'
          errorDiv.style.fontSize = '12px'
          errorDiv.style.marginTop = '5px'
          errorDiv.innerHTML = errors[field].join(', ')
          
          let parent = input.closest('.form-group');
          
          if (parent) {
            parent.appendChild(errorDiv);
          } else {
            input.parentNode.insertBefore(errorDiv, input.nextSibling);
          }
        } else {
          const dataIeElement = form.querySelector(`[data-ie="${fieldName}"]`);
          if (dataIeElement) {
            const errorDiv = document.createElement('div')
            errorDiv.className = 'validation-error'
            errorDiv.style.color = 'red'
            errorDiv.style.fontSize = '12px'
            errorDiv.style.marginTop = '5px'
            errorDiv.innerHTML = errors[field].join(', ')
            dataIeElement.appendChild(errorDiv)
          }
        }
      })
    }

    return {
      success: false,
      data: error.response?.data || null,
      message: error.response?.data?.message || 'Request failed'
    }
  }
}